import CreatePurchaseOrderPage from './CreatePurchaseOrderPage';
import ChooseSupplierStepPage from './ChooseSupplierStepPage';
import OrderDataStepPage from './OrderDataStepPage';

export default CreatePurchaseOrderPage;
export { ChooseSupplierStepPage, OrderDataStepPage };
